import { useEffect, useState } from "react";
import { Button, Form, Input } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";
import FirmSelectList from "../firm/FirmSelectList";

export default function FirmPosDeviceModal({ device, onSuccess }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (device) {
            form.setFieldsValue({
                firmId: device.firmId,
                name: device.name,
                address: device.address,
                serialNumber: device.serialNumber,
                type: device.type || 'PAVO',
            });
        } else {
            form.setFieldsValue({ type: 'PAVO' });
        }
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = device
                ? await ApiService.FirmPosDevice.EditFirmPosDevice(device.id, values)
                : await ApiService.FirmPosDevice.CreateFirmPosDevice(values);
            if (res.success) onSuccess && onSuccess();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item name="firmId" label={t('Firm')} rules={[{ required: true, message: t('Please select a firm') }]}>
                <FirmSelectList all={true} style={{ width: '100%' }} showSearch optionFilterProp="children" placeholder={t('Firm')} />
            </Form.Item>
            <Form.Item name="name" label={t('Name')} rules={[{ required: true, message: t('Please enter name') }]}>
                <Input />
            </Form.Item>
            <Form.Item
                name="address"
                label={t('Address')}
                rules={[{ required: true, message: t('Please enter address') }]}
                extra={t('Local PAVO proxy (nginx) address, e.g. http://127.0.0.1:9000')}
            >
                <Input placeholder="http://127.0.0.1:..." />
            </Form.Item>
            <Form.Item name="serialNumber" label={t('Serial Number')} rules={[{ required: true, message: t('Please enter serial number') }]}>
                <Input />
            </Form.Item>
            <Form.Item name="type" label={t('Type')}>
                <Input placeholder="PAVO" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Button type="primary" htmlType="submit" loading={loading}>{t('Save')}</Button>
            </Form.Item>
        </Form>
    );
}
